import { Routes } from '@angular/router';
import { langMatcher, notfoundMatcher } from './share/entity/html-suffix-url-matcher';

export const routes: Routes = [
  {
    matcher: notfoundMatcher,
    loadComponent: () =>
      import('./not-found/not-found.component').then(mod => mod.NotFoundComponent)
  },
  {
    matcher: langMatcher,
    loadChildren: () =>
      import('./web-generator/template-generator/template-generator.routes').then(m => m.templateGeneratorRoutes)
  },
  { path: '**', redirectTo: '404' },
];
